import { Clock, DollarSign, ShieldCheck, MapPin } from "lucide-react";

const items = [
  { icon: Clock, label: "Same Day Moves" },
  { icon: DollarSign, label: "No Hidden Costs" },
  { icon: ShieldCheck, label: "Fully Insured" },
  { icon: MapPin, label: "Melbourne Based" },
];

const TrustStrip = () => (
  <section className="relative bg-[#111111] py-4 md:py-5">
    {/* Thin black connector strip — bridges the hero's diagonal divider down to
        the trust bar so no yellow gap shows through at the junction. Sits above
        the yellow hero background but below all icons and labels. */}
    <span
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 -top-2 h-4 bg-[#111111] z-0"
    />
    <div className="container relative z-10">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 max-w-3xl mx-auto">
        {items.map((item) => (
          <div key={item.label} className="trust-item group flex flex-col items-center gap-1.5 cursor-default">
            <div className="trust-icon relative w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center bg-[#FFC300]/8 backdrop-blur-md border border-[#FFC300]/15 shadow-[0_0_12px_rgba(255,195,0,0.06)]">
              <div className="absolute inset-0.5 rounded-full bg-gradient-to-b from-white/[0.07] to-transparent pointer-events-none" />
              <item.icon className="w-5 h-5 md:w-6 md:h-6 text-[#FFC300] relative z-10" strokeWidth={1.8} />
            </div>
            <span className="trust-label text-xs md:text-sm font-bold text-white/90 tracking-wide text-center">
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustStrip;
